var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('PageLoader'):_vm._e(),(!_vm.loading)?_c('NavBar'):_vm._e(),(!_vm.loading)?_c('router-view',{staticClass:"pt-lg-7"}):_vm._e(),(!_vm.loading)?_c('FooterVue',{attrs:{"categories":_vm.categories,"aboutus":_vm.aboutus,"branches":_vm.branches}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }